import {PROPERTY_SELECTOR_SIGIL} from '../constants';

/**
 * Create a function for mapping a provider compoent id, property selector, to a consumer component id, property name and path
 * Sample mapping Obj
 * mappings: {
 * 	providerComponent@providerProp: {
 * 		selectorId@selectorProp: 'pathValue'
 * 	}
 * }
 * @function createAddMapping
 * @private
 * @param {Object} mappings
 * @returns {function} - A function for adding a mapping
 */
export default function createAddMapping(mappings) {
	/**
	 * @function addMapping
	 * @private
	 * @param {Object} providerDetail - A object that will contain providerId, providerPropName, providerPropPath
	 * @param {Object} consumerDetail - A object that will contain consumerId, consumerPropName
	 */
	return function addMapping(providerDetail, consumerDetail) {
		const {providerId, providerPropName, providerPropPath} = providerDetail;
		const {consumerId, consumerPropName} = consumerDetail;
		const providerKey = `${providerId}${PROPERTY_SELECTOR_SIGIL}${providerPropName}`;
		const consumerKey = `${consumerId}${PROPERTY_SELECTOR_SIGIL}${consumerPropName}`;

		if (!mappings[providerKey]) mappings[providerKey] = {}; // eslint-disable-line no-param-reassign

		// eslint-disable-next-line no-param-reassign
		mappings[providerKey][consumerKey] = providerPropPath;
	};
}
